import { SurveyForm } from "./SurveyForm";

import { StringArrayField, StringField } from "@/core/fields";

export class VdtSurveyForm extends SurveyForm {
  public question1: string | undefined = undefined;
  public question2: string | undefined = undefined;
  public question3: string | undefined = undefined;
  public question4: string | undefined = undefined;
  public question5: string | undefined = undefined;
  public question6: string | undefined = undefined;
  public question7: string | undefined = undefined;
  public question8: string | undefined = undefined;
  public question9: string | undefined = undefined;
  public question10: string | undefined = undefined;
  public question11: string | undefined = undefined;
  public question12: string | undefined = undefined;
  public question13: string | undefined = undefined;
  public question14: string | undefined = undefined;
  public question15: string | undefined = undefined;
  public question16: string[] = [];
  public question17: string | undefined = undefined;

  public constructor(firestoreData?: Record<string, unknown>) {
    super(firestoreData);
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);

    this.isPrintable = true;
  }

  public fromFirestore(data: Record<string, unknown>): VdtSurveyForm {
    super.fromFirestore(data);

    this.question1 = StringField.fromFirestore(data.question1);
    this.question2 = StringField.fromFirestore(data.question2);
    this.question3 = StringField.fromFirestore(data.question3);
    this.question4 = StringField.fromFirestore(data.question4);
    this.question5 = StringField.fromFirestore(data.question5);
    this.question6 = StringField.fromFirestore(data.question6);
    this.question7 = StringField.fromFirestore(data.question7);
    this.question8 = StringField.fromFirestore(data.question8);
    this.question9 = StringField.fromFirestore(data.question9);
    this.question10 = StringField.fromFirestore(data.question10);
    this.question11 = StringField.fromFirestore(data.question11);
    this.question12 = StringField.fromFirestore(data.question12);
    this.question13 = StringField.fromFirestore(data.question13);
    this.question14 = StringField.fromFirestore(data.question14);
    this.question15 = StringField.fromFirestore(data.question15);
    this.question16 = StringArrayField.fromFirestore(data.question16);
    this.question17 = StringField.fromFirestore(data.question17);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.question1 = StringField.toFirestore(this.question1);
    firestoreData.question2 = StringField.toFirestore(this.question2);
    firestoreData.question3 = StringField.toFirestore(this.question3);
    firestoreData.question4 = StringField.toFirestore(this.question4);
    firestoreData.question5 = StringField.toFirestore(this.question5);
    firestoreData.question6 = StringField.toFirestore(this.question6);
    firestoreData.question7 = StringField.toFirestore(this.question7);
    firestoreData.question8 = StringField.toFirestore(this.question8);
    firestoreData.question9 = StringField.toFirestore(this.question9);
    firestoreData.question10 = StringField.toFirestore(this.question10);
    firestoreData.question11 = StringField.toFirestore(this.question11);
    firestoreData.question12 = StringField.toFirestore(this.question12);
    firestoreData.question13 = StringField.toFirestore(this.question13);
    firestoreData.question14 = StringField.toFirestore(this.question14);
    firestoreData.question15 = StringField.toFirestore(this.question15);
    firestoreData.question16 = StringArrayField.toFirestore(this.question16);
    firestoreData.question17 = StringField.toFirestore(this.question17);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): VdtSurveyForm {
    super.fromOfflineCache(data);

    this.question1 = StringField.fromOfflineCache(data.question1);
    this.question2 = StringField.fromOfflineCache(data.question2);
    this.question3 = StringField.fromOfflineCache(data.question3);
    this.question4 = StringField.fromOfflineCache(data.question4);
    this.question5 = StringField.fromOfflineCache(data.question5);
    this.question6 = StringField.fromOfflineCache(data.question6);
    this.question7 = StringField.fromOfflineCache(data.question7);
    this.question8 = StringField.fromOfflineCache(data.question8);
    this.question9 = StringField.fromOfflineCache(data.question9);
    this.question10 = StringField.fromOfflineCache(data.question10);
    this.question11 = StringField.fromOfflineCache(data.question11);
    this.question12 = StringField.fromOfflineCache(data.question12);
    this.question13 = StringField.fromOfflineCache(data.question13);
    this.question14 = StringField.fromOfflineCache(data.question14);
    this.question15 = StringField.fromOfflineCache(data.question15);
    this.question16 = StringArrayField.fromOfflineCache(data.question16);
    this.question17 = StringField.fromOfflineCache(data.question17);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.question1 = StringField.toOfflineCache(this.question1);
    firestoreData.question2 = StringField.toOfflineCache(this.question2);
    firestoreData.question3 = StringField.toOfflineCache(this.question3);
    firestoreData.question4 = StringField.toOfflineCache(this.question4);
    firestoreData.question5 = StringField.toOfflineCache(this.question5);
    firestoreData.question6 = StringField.toOfflineCache(this.question6);
    firestoreData.question7 = StringField.toOfflineCache(this.question7);
    firestoreData.question8 = StringField.toOfflineCache(this.question8);
    firestoreData.question9 = StringField.toOfflineCache(this.question9);
    firestoreData.question10 = StringField.toOfflineCache(this.question10);
    firestoreData.question11 = StringField.toOfflineCache(this.question11);
    firestoreData.question12 = StringField.toOfflineCache(this.question12);
    firestoreData.question13 = StringField.toOfflineCache(this.question13);
    firestoreData.question14 = StringField.toOfflineCache(this.question14);
    firestoreData.question15 = StringField.toOfflineCache(this.question15);
    firestoreData.question16 = StringArrayField.toOfflineCache(this.question16);
    firestoreData.question17 = StringField.toOfflineCache(this.question17);

    return firestoreData;
  }
}
